import axiosInstance from '../helpers/axiosInstance';

export const getDeliverApi = async (searchKey) => {
    const response = await axiosInstance.get('staff/listOfProjectsForOutwards');
    return response.data;
};